export { DMS_MODULE } from '../constants';
export const NAME = 'Vozidlo';
export const VOZIDLO_MERGE = 'VozidloMerge';
export const VOZIDLO_MERGE_VALUES = 'MergeVozidloValues';
export const MERGE = 'Merge';
export const CRUMB_LABEL_KEY = 'grdVozidlo';
export const CDB = 'cdb';
export const VOZIDLO_CDB = 'CdbCarSet';
export const CUSTOMER_FILES = 'CustomerFiles';
export const VEHICLE_HISTORY = 'VehicleHistory';
export const VEHICLE_INSURANCE_DETAILS = 'VehicleInsuranceDetails';
export const CUSTOMER_OFFERS = 'CustomerOffers';
export const INSURANCE_REPORT = 'InsuranceReport';
export const MENU_CODE = 'KZV_Vozidla';
export const DEFAULT_START_MONTH = 0;
export const DMS_AS_GOLDEN_ACCOUNT_ID_PREFIX = 'DMS';
export const DMS_CREATED_GOLDEN_ACCOUNT_ID_KVPS_ISSUE = 'DMS_CREATED_GOLDEN_ACCOUNT_ID_KVPS_ISSUE';
export const CROSS_DEALER_KVPS_SEARCH_ISSUE = 'CROSS_DEALER_KVPS_SEARCH_ISSUE';
export const ACTUAL_CUSTOMER_DATA_INVALID_IN_CDB_DATA_ISSUE = 'ACTUAL_CUSTOMER_DATA_INVALID_IN_CDB_DATA_ISSUE';
export const NEW_CUSTOMER_CREATE_ISSUE = 'NEW_CUSTOMER_CREATE_ISSUE';
export const CUSTOMER_ABSENT_IN_PARTNER_TABLE = 'CUSTOMER_ABSENT_IN_PARTNER_TABLE';
export const SUCCESS = 'SUCCESS';
export const VALID_VIN_LENGTH = 17;
export const TENANT_NAME = 'TENANT_NAME';
export const CUSTOMER_CONTACT_DETAILS = 'CustomerContactDetails';

export const DEPENDENT_TABLES = <const>[
	MERGE,
	VOZIDLO_MERGE_VALUES,
];
export const DUPLICITY_CHECK_API = 'Duplicity';
export const DUPLICITY_TABLE = 'MergeVozidlo';
export const DEPENDENT_TABLES_VOZIDLO = <const>[
	CUSTOMER_CONTACT_DETAILS,
	DUPLICITY_TABLE,
	CUSTOMER_FILES,
	VEHICLE_HISTORY,
	VEHICLE_INSURANCE_DETAILS,
	CUSTOMER_OFFERS,
	INSURANCE_REPORT
];
const vozidloDataType = {
	HISTORIEOPRAV: 'HistorieOprav',
	OBRATYOPRAV: 'ObratyOprav',
	SERVICEKEY: 'ServiceKey',
	SDA: 'Sda',
	ZAVADA: 'Zavada',
	CUSTOMER_FEEDBACK: 'CUSTOMER_FEEDBACK',
};
export const VOZIDLO_DATA_TYPE = Object.freeze(vozidloDataType);
export const VOZIDLO_DATA = 'VozidloData';
export type DependentTableNames = typeof DEPENDENT_TABLES[number] & typeof DEPENDENT_TABLES_VOZIDLO[number];

export const MERGE_PROPS = {
	fromKVZButton: 'cmdVsetkyKontaktHodnoty',
	fromKontaktButton: 'cmdVsetkyKZVHodnoty',
	updateButton: 'cmdVozidloMerge',
	createButton: 'cmdZalozVozidlo',
	duplicateColumnName: 'VozidloKontaktHodnoty',
	sourceColumnName: 'VozidloHodnoty',
	labelKeyVysledek: 'VozidloMergeHodnoty',
};

export const SDA_VIN_PREFIX = 4;
export const DELKA_VIN = 17;
export const VOZIDLO_ONGOING_EDITS = 'VOZIDLO_ONGOING_EDITS';

export enum TAB_NAMES{
	HLAVNIUDAJE = 'HlavniUdaje',
	DALSIINFO = 'DalsiInfo',
	UPDATEDETAILS = 'UpdateDetails',
}

export const TABS = {
	[TAB_NAMES.HLAVNIUDAJE]: { id: TAB_NAMES.HLAVNIUDAJE, labelKey: 'TabOrg0' },
	[TAB_NAMES.DALSIINFO]: { id: TAB_NAMES.DALSIINFO, labelKey: 'D_Info' },
	[TAB_NAMES.UPDATEDETAILS]: { id: TAB_NAMES.UPDATEDETAILS, labelKey: 'UpdateDetails' },
};
